export default bytes => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const decimals = 2;
  const labels = ['б', 'кБ', 'мБ', 'гБ'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / k ** i).toFixed(decimals))} ${labels[i]}`;
};
